/* eslint-disable  import/no-cycle -- need */
import { apiHandler } from '../utils/apiHandler';
import { combineDataFields, maskString, addToStaticTable } from '../utils/util';
import { entityOperations } from './CustomOperations/entityOperations';
import { validateJPGiftCardAmount } from './CustomOperations/japanGiftCardOperations';
import {
  invokeCalculateTransferpoints,
  invokeGetPartnerTransferRateandLabel,
} from './CustomOperations/mrtJapanOperations';
import { optionsFromExpandableTable } from './CustomOperations/expandableTableOperations';
import { deleteExpandableTablesData } from './CustomOperations/deleteExpandableTablesData';
import { transferFieldData } from './CustomOperations/transferFieldDataOperations';
import { decideJourneyType, populateHardshipSelectOptionLabel } from './CustomOperations/hardshipAuNz';
import { getNamePermutations } from './CustomOperations/getNamePermutationsOperation';

const setValue = require('lodash/set');
const getVal = require('lodash/get');
/* eslint-disable max-len -- need */
/* eslint-disable no-restricted-syntax -- need */
/* eslint-disable no-await-in-loop -- need */
/* eslint complexity: ["error", 27] -- need to increase complexity */
export const performOperations = async (props) => {
  /**
   * Operations like onChange, onBlur, onFocus, onClick, etc for different components can be performed here
   * Operations which invokes some specific functions or updates states can be managed here
   */
  const { operations } = props;
  for (const operation of operations) {
    switch (operation.type) {
      case 'combineFieldsAndAddToDataObject': {
        const newField = combineDataFields(operation.fieldsToCombine, props.dataObject);
        if (newField !== '') {
          operation.addField?.forEach((update) => {
            setValue(props.dataObject, `${update.to}.${update.addAs}`, newField);
          });
        }
        break;
      }
      case 'decideHardshipJourneyType': {
        decideJourneyType(props);
        break;
      }
      case 'populateHardshipSelectOptionLabel': {
        populateHardshipSelectOptionLabel(props);
        break;
      }
      case 'calculate_MRT_Transferpoints': {
        invokeCalculateTransferpoints({ ...props, operation });
        break;
      }
      case 'spreadObjectAndUpdateState': {
        const { functionObject } = props;
        const { dataObject } = props;
        const sourceObject = getVal(dataObject, operation.sourceObjectKey);
        const stateUpdateMethod = functionObject[operation.stateUpdateMethod];
        stateUpdateMethod((prevPayload) => {
          const newPayload = { ...prevPayload, ...sourceObject };
          if (operation.stateUpdateMethod === 'setFormSubmissionPayload') {
            newPayload.elemId = null;
          }
          return newPayload;
        });
        break;
      }
      case 'getPartnerTransferRateandLabel': {
        invokeGetPartnerTransferRateandLabel(props);
        break;
      }
      case 'callApi': {
        // const { apiName, requestKeys } = apiConfig;
        await apiHandler({ ...props, ...operation });
        break;
      }
      case 'Options_From_ExpandableTable': {
        optionsFromExpandableTable({ ...props, operation });
        break;
      }
      case 'Transfer_Field_Data': {
        transferFieldData({ ...props, operation });
        break;
      }
      case 'DeleteExpandableTablesData': {
        deleteExpandableTablesData({ ...props, operation });
        break;
      }
      case 'maskString': {
        const { dataObject, value } = props;
        const { maskParams } = operation;
        const {
          maskPattern, from, to, addAs,
        } = maskParams;
        const maskedValue = maskString({
          stringToMask: value, maskPattern, from, to,
        });
        setValue(dataObject, `formSubmissionPayload.${addAs}`, maskedValue);
        break;
      }
      case 'validateJPGiftCardAmount': {
        validateJPGiftCardAmount(props);
        break;
      }
      case 'addEntity':
      case 'removeEntity':
      case 'editEntity':
      {
        entityOperations({ props, entityOperationType: operation.type });
        break;
      }
      case 'updateDataOnS3': {
        props.functionObject.putDataToS3(operation.isPartialSubmit, null, operation.status);
        break;
      }
      case 'updatePayload': {
        const {
          value,
          functionObject,
          dataObject,
        } = props;
        let fetchedValue = value;
        const { setFormSubmissionPayload } = functionObject;
        const { keyToUpdate, value: operationValue } = operation;
        if (operationValue) {
          fetchedValue = getVal(dataObject, operationValue);
        }
        if (fetchedValue) {
          setFormSubmissionPayload((prev) => ({ ...prev, elemId: null, [keyToUpdate]: fetchedValue }));
        } else {
          setFormSubmissionPayload((prev) => {
            delete prev[keyToUpdate];
            return { ...prev, elemId: null };
          });
        }
        break;
      }
      case 'addToStaticTable': {
        addToStaticTable(props, operation.staticValues);
        break;
      }
      case 'getNamePermutations': {
        getNamePermutations(props);
        break;
      }
      case 'addDataFromSessionToPayload': {
        const {
          functionObject,
        } = props;
        const { setFormSubmissionPayload } = functionObject;
        const payloadUpdate = {};
        operation.sessionValues.forEach((session) => {
          payloadUpdate[session.addAs] = window.sessionStorage.getItem(session.sessionKey);
        });
        setFormSubmissionPayload((prev) => ({ ...prev, elemId: null, ...payloadUpdate }));
        break;
      }
      default:
    }
  }
};
/* eslint-enable no-await-in-loop -- need */
/* eslint-enable no-restricted-syntax -- need */
/* eslint-enable max-len -- need */
/* eslint-enable  import/no-cycle -- need */
